export const HUB_INSTALLS = 'HUB_INSTALLS';
export const FIRST_PUBLISHED = 'FIRST_PUBLISHED';
export const NAME = 'NAME';
export const RANDOM = 'RANDOM';
export const RELEVANCE = 'RELEVANCE'; // This is just for convenience. Always send appropriate sort field for selected plan type.

export const PRICE = 'PRICE';
export const MONTHLY_PRICE = 'MONTHLY_PRICE';
export const YEARLY_PRICE = 'YEARLY_PRICE';
export const ONE_TIME_PRICE = 'ONE_TIME_PRICE';